import { observer } from "mobx-react-lite"
import { useNavigate } from "react-router-dom"

import { Compound as Table } from "@/components/table"
import { ClFarmStore } from "@/domains/cl-farm/cl-farm-store"
import { ChevronRightIcon } from "@/domains/icons"
import { AprColumn } from "@/domains/pools/components/apr-column"
import { PoolBalanceColumn } from "@/domains/pools/components/pool-balance-column"
import { PoolInfoColumn } from "@/domains/pools/components/pool-info-column"
import { PoolStakedColumn } from "@/domains/pools/components/pool-staked-column"
import { StakedColumn } from "@/domains/pools/components/staked-column"
import { TvlColumn } from "@/domains/pools/components/tvl-column"
import { WalletColumn } from "@/domains/pools/components/wallet-column"

export const ClFarmsTableRowContent = observer(
  ({ pool, chainSlug, isCompact }: { pool: ClFarmStore; chainSlug: string; isCompact: boolean }) => {
    const navigate = useNavigate()
    return (
      <Table.Tr
        className="group cursor-pointer border-t border-t-p400-light"
        onClick={() => {
          navigate(`/liquidity/cl-farms/${pool.address.toString()}/mint`)
        }}
      >
        <Table.Td className=" px-0 py-0 group-hover:bg-p300 sm:px-0">
          <div className="flex h-full w-full items-center justify-center">
            <ChevronRightIcon size={16} className="text-t300 group-hover:text-t200" />
          </div>
        </Table.Td>
        <Table.Td className="bg-p400 pl-4 group-hover:bg-p400/40">
          <PoolInfoColumn pool={pool} chainSlug={chainSlug} />
        </Table.Td>
        <Table.Td className="group-hover:bg-p400/40">
          <AprColumn pool={pool} isCompact={isCompact} />
        </Table.Td>

        <Table.Td className="text-right group-hover:bg-p400/40">
          <TvlColumn pool={pool} isCompact={isCompact} />
        </Table.Td>
        <Table.Td className="text-right group-hover:bg-p400/40">
          <StakedColumn pool={pool} isCompact={isCompact} />
        </Table.Td>
        <Table.Td className="text-right group-hover:bg-p400/40">
          <WalletColumn pool={pool} isCompact={isCompact} />
        </Table.Td>
        <Table.Td className="text-right group-hover:bg-p400/40">
          <PoolBalanceColumn pool={pool} isCompact={isCompact} />
        </Table.Td>
        <Table.Td className="text-right group-hover:bg-p400/40">
          <PoolStakedColumn pool={pool} isCompact={isCompact} />
        </Table.Td>
      </Table.Tr>
    )
  },
)
